export const locale = {
    lang: 'en',
    data: {
        'TECHNOLOGIES': {
            'TECHNOLOGIES': 'Technologies'
        }
    }
};
